import { render, staticRenderFns } from "./InfiniteData.vue?vue&type=template&id=bd117a58&"
import script from "./InfiniteData.vue?vue&type=script&lang=js&"
export * from "./InfiniteData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports